import { Popover, Tag } from 'antd';
import React from 'react';
import { FlowInstance } from '../../types';
import moment from 'moment-timezone';
import { FlowContent, FlowContentWrapper, FlowHeader, FlowNameItem } from './styled';

export const FlowTag = ({
  flows,
  onClickFlow,
}: {
  flows: FlowInstance[];
  onClickFlow: (flowInstance: FlowInstance) => void;
}) => {
  if (!flows || flows.length === 0) return null;

  return (
    <Popover
      placement="rightTop"
      overlayInnerStyle={{ padding: 2 }}
      content={
        <FlowContentWrapper>
          <FlowHeader>Flows in this session</FlowHeader>
          <FlowContent>
            {flows
              .sort(
                (a, b) =>
                  moment(a.flow_start_timestamp).diff(moment(b.flow_start_timestamp)) ||
                  moment(a.flow_end_timestamp).diff(moment(b.flow_end_timestamp)),
              )
              .map((flow) => (
                <FlowNameItem
                  key={flow.flow_identifier}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickFlow(flow);
                  }}
                >
                  {`${flow.flow_name} (${moment(flow.flow_start_timestamp).format('HH:mm:ss')} - ${moment(flow.flow_end_timestamp).format('HH:mm:ss')})`}
                </FlowNameItem>
              ))}
          </FlowContent>
        </FlowContentWrapper>
      }
      trigger={['hover', 'click']}
    >
      <Tag onClick={(e) => e.stopPropagation()}>{`Flow (${flows.length})`}</Tag>
    </Popover>
  );
};
